let color = '#343434';
if (window.matchMedia &&  window.matchMedia('(prefers-color-scheme: dark)').matches) {
    color = '#e8e8e8';
}
export default {
	style: {
        base: {
            color: color,
            fontFamily: '"Noto Sans", sans-serif',
            fontSize: '16px',
            '::placeholder': {
                color: 'transparent'
            }
        }
    },
    fonts: [{
        cssSrc: 'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,400;0,700;1,400&display=swap'
    }]
}